module.exports = __webpack_public_path__ + "static/media/13import-29.908d24df.xlsx";